import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { RepresentantePage } from './representante';

@NgModule({
  declarations: [
    RepresentantePage,
  ],
  imports: [
    IonicPageModule.forChild(RepresentantePage),
  ],
})
export class RepresentantePageModule {}



// WEBPACK FOOTER //
// ./src/pages/representante/representante.module.ts